import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["href", "title"];
import { useEntries } from "../features/useEntries";
import { useConfig } from '../features/useConfig';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ArxivLink',
    setup(__props) {
        const { arxivLink, linkText, linkTitle } = useConfig();
        const { loading } = useEntries();
        return (_ctx, _cache) => {
            return (_unref(arxivLink))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (!_unref(loading))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                            _createElementVNode("a", {
                                href: _unref(arxivLink),
                                target: "_blank",
                                rel: "noopener",
                                title: _unref(linkTitle),
                                class: "is-external"
                            }, _toDisplayString(_unref(linkText)), 9 /* TEXT, PROPS */, _hoisted_2)
                        ]))
                        : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true);
        };
    }
});
